import { Store } from "vuex";
import { namespace as suggestionsNamespace } from "../modules/suggestions/suggestions";
export class SuggestionsStore {
    private store: Store<any>;
    constructor(store: Store<any>) {
        this.store = store;
    }
    /**
     * Gets the suggestions for search
     * @param portalId portalid
     * @param searchCriteria searchCriteria for suggestions
     */
    public async getSearchSuggestions(portalId: number, searchCriteria: string): Promise<Object[] | null> {
        return this.store.dispatch(`${suggestionsNamespace}/getSearchSuggestions`, { portalId, searchCriteria });
    }
}
